<template>
    <div class="container">
        <div class="searchBox_top">
            <el-button type="primary" @click="approvalSuppliers">{{$t('supplierManage.SuppliersApproval')}}</el-button><!--审批-->
            <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        </div>
        
        <el-card class="box-card" v-if="supplierCode"><!--供应商品类信息 从供应商资源管理 点击供应商编码 跳过来的才显示-->
            <div slot="header" class="clearfix">
                <span>{{$t('supplierManage.supplierCategoryInfo')}}</span>
            </div>
            <el-form :model="CategoryInfoForm" ref="CategoryInfoForm" :rules="CategoryInfoRules" label-width="120px">
                <el-row>
                    <el-form-item label="Category1" prop="Category1">
                        <el-checkbox-group v-model="CategoryInfoForm.Category1">
                            <el-checkbox label="美食/餐厅线上活动" name="Category1"></el-checkbox>
                            <el-checkbox label="地推活动" name="Category1"></el-checkbox>
                            <el-checkbox label="线下主题活动" name="Category1"></el-checkbox>
                            <el-checkbox label="单纯品牌曝光" name="Category1"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="Category2" prop="Category2">
                        <el-checkbox-group v-model="CategoryInfoForm.Category2">
                            <el-checkbox label="美食/餐厅线上活动" name="Category2"></el-checkbox>
                            <el-checkbox label="地推活动" name="Category2"></el-checkbox>
                            <el-checkbox label="线下主题活动" name="Category2"></el-checkbox>
                            <el-checkbox label="单纯品牌曝光" name="Category2"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-card>
        <el-card class="box-card"><!--供应商基础信息-->
            <div slot="header" class="clearfix">
                <span>{{$t('supplierManage.supplierBasicInfo')}}</span>
            </div>
            <el-form :model="queryCondition" ref="queryCondition" label-width="120px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item :label="$t('supplierManage.supplierChinese')" prop="supplierChinese">
                            <!--供应商中文名称-->
                            <el-input v-model="queryCondition.supplierChinese" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="supplierEnglish">
                            <!--供应商简称-->
                            <el-input v-model="queryCondition.supplierEnglish" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('supplierManage.supplierInvitationCode')" prop="supplierEnglish">
                            <!--供应商邀请码-->
                            <el-input v-model.trim="queryCondition.supplierEnglish" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('supplierManage.auditStatus')" prop="supplierEnglish">
                            <!--审核状态-->
                            <ic-select clearable table="BASE" field="DC" v-model="queryCondition.processNode"></ic-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item :label="$t('supplierManage.supplierEnglish')" prop="supplierEnglish">
                            <!--供应商英文名称-->
                            <el-input v-model="queryCondition.supplierEnglish" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('supplierManage.supplierType')" prop="supplierEnglish">
                            <!--供应商类型-->
                            <ic-select clearable table="BASE" field="DC" v-model="queryCondition.processNode"></ic-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('supplierManage.supplierInviter')" prop="supplierEnglish">
                            <!--供应商邀请人-->
                            <el-input v-model.trim="queryCondition.supplierEnglish" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-button type="primary" @click="addSupplierContacts">{{$t('common.add')}}</el-button><!--添加-->
            <el-table :data="contactsList" ref="contactsList" border highlight-current-row max-height='420'>
                <el-table-column prop="templateName" :label="$t('supplierManage.supplierContacts')"></el-table-column>
                <el-table-column :label="$t('base.linePrice.operation')">
                    <template slot-scope="scope">
                        <el-link @click="delSupplierContacts(scope.$index,contactsList,scope.row)" type="primary" v-if="scope.$index!=0">{{$t('common.del')}}</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card class="box-card"><!--保密协议  非专用 不显示-->
            <div slot="header" class="clearfix">
                <span>{{$t('supplierManage.confidentialityAgreement')}}</span>
            </div>
        </el-card>
        <el-card class="box-card"><!--供应商地址信息-->
            <div slot="header" class="clearfix">
                <span>{{$t('supplierManage.supplierAddressInfo')}}</span>
            </div>
        </el-card>
        <el-card class="box-card"><!--其他附件-->
            <div slot="header" class="clearfix" style="display: flex;align-items: center;">
                <span>{{$t('common.otherAttachments')}}</span>
                <el-upload
                    style="margin-left:20px"
                    ref="upload"
                    action="upload"
                    :http-request="uploadConfirm"
                    :show-file-list="false"
                    multiple
                    name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button><!--选取文件-->
            </el-upload>
            </div>
            <el-table :data="fileList" border highlight-current-row class="table">
                <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px"><!--文件-->
                    <template slot-scope="scope">
                        <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column><!--创建人-->
                <el-table-column sortable prop="createDate" :label="$t('common.createDate')" min-width="130px"><!--创建时间-->
                    <template slot-scope="scope">
                        {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
                    </template>
                </el-table-column>
                <el-table-column prop="tmDocumentId"  min-width="130px">
                    <template slot-scope="scope">
                        <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList)">{{$t('common.del')}}</el-link><!--删除-->
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="$t('supplierManage.approvalWindow')" :visible.sync="approvalVisible" width="25%">
            <el-form :model="approvaForm" ref="approvaForm" :rules="approvaRules" inline  label-width="90px">
                <el-form-item :label="$t('storeFeedback.auditor')" prop="auditor">
                    <el-input v-model="approvaForm.auditor" disabled></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.approvalTime') " prop="approvalTime">
                    <el-input v-model="approvaForm.approvalTime" disabled></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.approvalResults') " prop="approvalResults">
                    <el-radio-group v-model="approvaForm.approvalResults" @change="ResultsChange">
                        <el-radio label="1">{{$t('common.pass')}}</el-radio>
                        <el-radio label="2">{{$t('common.noPass')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('common.approvalRemarks') " prop="approvalRemarks" :rules="approvaForm.approvalResults == 2 ? approvaForm.approvalRemarks :[]" >
                    <el-input v-model="approvaForm.approvalRemarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="300" style="width:200px"></el-input>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="approvalVisible = false" type="primary">取 消</el-button>
                <el-button type="primary" @click="approvalConfirm()">确 定</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import IcSelect from "@/components/common/icSelect";
import {fileService} from "@/api/common/file-utils";
export default {
  components: {IcSelect},
        data(){
            return {
                contactsList:[1],
                queryCondition: {},
                fileList: [],
                supplierCode:false,
                CategoryInfoForm:{
                    Category1:[],
                    Category2:[],
                },
                CategoryInfoRules:{
                    Category1: [
                        { type: 'array', required: true, message: "不能为空", trigger: 'change' }
                    ],
                    // Category2: [
                    //     { type: 'array', required: true, message: this.$t("common.canNotBeEmpty"), trigger: 'change' }
                    // ],
                },
                approvaForm:{
                    approvalTime:this.$options.filters["dateFormatFilter"]( new Date() ),
                    approvalResults:'',
                },
                approvaRules:{
                    approvalResults: [
                        {required: true,message: this.$t("common.canNotBeEmpty"),trigger: "blur"}
                    ],
                    approvalRemarks: [
                        {required: true,message: this.$t("common.canNotBeEmpty"),trigger: "blur"}
                    ],
                },
                approvalVisible:false,
            }
        },
        created() {
            this.supplierCode = this.$route.query.supplierCode;
            this.getFiles();
        },
        methods: {
            //添加供应商联系人
            addSupplierContacts(){
                this.contactsList.push({})
            },
            delSupplierContacts(index,data,row){
                if(row.id){
                    //请确认是否删除!
                  this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
                      confirmButtonText: this.$t('common.confirm'),
                      cancelButtonText: this.$t('common.cancel'),
                      cancelButtonClass:'el-button--primary',
                      confirmButtonClass:'el-button--primary',
                      type: 'warning'
                  }).then(() => {
                      dcService.deleteDc(row.id).then((res)=>{
                          if(res.meta.success){
                              Message({message: this.$t('common.delSuccess'), type: "success"});
                              this.queryData();
                          }else{
                              Message({message: res.meta.msg, type: "error"});
                              this.queryData();
                          }
                      });
                  }).catch(() => {

                  });
                }else{
                    data.splice(index, 1);
                }
                
                
            },
            //审批
            approvalSuppliers(){
                this.approvalVisible = true
            },
            //审批
            approvalConfirm(){
                let that = this;
                this.$refs.approvaForm.validate(valid => {
                    if (valid) {
                        console.log(that.approvaForm);
                    } else {
                    return false;
                    }
                });
                this.approvalVisible = true
            },
            ResultsChange(){
                 this.$refs.approvaForm.clearValidate()
            },
            //文件列表数据获取
            getFiles: function(){
                let attachment = {};
                attachment.seq = '1';
                attachment.tsRecId = 4484;
                attachment.tsReckindId = 'QUOTATION_APPLY';
                fileService.getFileList(attachment).then((fileRes)=>{
                    this.fileList = fileRes;
                })
            },
            //文件上传
            uploadConfirm: function(item) {
                let _this = this;
                let formData = new FormData();
                 formData.append("file", item.file);
                fileService.fileUpload(formData).then((res)=>{
                    //调用成功后调用后台方法进行文件关系维护
                    let attachment = {};
                    attachment.documents = res.data;
                    attachment.seq = '1';
                    attachment.tsRecId = this.ttQuotationApplyId;
                    attachment.tsReckindId = 'QUOTATION_APPLY';
                    fileService.saveFile(attachment).then((saveRes)=>{
                        _this.getFiles();
                    })
                }).catch((error)=>{
                    //文件上传失败
                    Message({message: this.$t('common.fileUploadFailed'), type: "error"});
                });
            },
            //文件下载
            downloadFile: function(row){
                fileService.downloadFile(row).then((res)=>{})
            },
            //文件删除
            deleteFile: function(tmDocumentId,index,files){
                fileService.deleteFile(tmDocumentId).then((res)=>{
                    //删除成功删除列表数据
                    files.splice(index, 1);
                })
            },
            historyBack: function(){
                this.$router.go(-1);
            },
        }

    }
</script>
<style lang="scss" scoped>
.searchBox_top{
    margin-bottom: 20px;
}
.el-table{
    margin-top: 10px;
}
</style>
